import TokenManager from "@/utils/TokenManager";

export default [
  {
    path: "/",
    beforeEnter: (to, from, next) => {
      TokenManager.getUserToken() === "" ? next("login") : next();
    },
    component: () =>
      import(/* webpackChunkName: "home" */ "@/views/HomePage.vue"),
    children: [
      {
        path: "",
        name: "dashboard",
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ "@/components/Dashboard.vue"
          )
      },
      {
        path: "factsheet",
        name: "factsheet",
        component: () =>
          import(
            /* webpackChunkName: "factsheet" */ "@/views/FactSheetPage.vue"
          )
      },
      {
        path: "factsheet/manage",
        name: "factsheet-manage",
        component: () =>
          import(
            /* webpackChunkName: "factsheet-manage" */ "@/views/FactSheetManage.vue"
          )
      },
      {
        path: "balancesheet",
        name: "balancesheet",
        component: () =>
          import(
            /* webpackChunkName: "balancesheet" */ "@/views/docs/BalanceSheetPage.vue"
          )
      },
      {
        path: "retirementsheet",
        name: "retirementsheet",
        component: () =>
          import(
            /* webpackChunkName: "retirementsheet" */ "@/views/docs/RetirementSheetPage.vue"
          )
      },
      {
        path: "templates",
        name: "templates",
        component: () =>
          import(
            /* webpackChunkName: "templates" */ "@/views/docs/TemplateListPage.vue"
          )
      },
      {
        path: "client",
        name: "client",
        component: () =>
          import(/* webpackChunkName: "client" */ "@/views/ClientPage.vue")
      },
      {
        path: "user",
        name: "user",
        component: () =>
          import(/* webpackChunkName: "user" */ "@/views/UsersPage.vue")
      },
      {
        path: "business-unit",
        name: "business-unit",
        component: () =>
          import(
            /* webpackChunkName: "business-unit" */ "@/views/BusinessUnitPage.vue"
          )
      },
      {
        path: "setting",
        name: "setting",
        component: () =>
          import(/* webpackChunkName: "setting" */ "@/views/SettingPage.vue")
      }
    ]
  },
  {
    path: "/login",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "login" */ "@/views/LoginPage.vue")
  },
  {
    path: "*",
    name: "notfound",
    component: () =>
      import(/* webpackChunkName: "notfound" */ "@/views/NotFoundPage.vue")
  }
];
